const usePage = async (path: string): Promise<object> => {
  const key = `page-${path.startsWith('/') ? path : '/' + path}`;

  const { data: page } = await useAsyncData(key, async () => {
    let page = await queryCollection("pages").where("uri", "=", path).first();

    if (!page) {
      const alternatePath = path.endsWith('/')
        ? path.slice(0, -1)
        : path + '/';
      page = await queryCollection("pages").where("uri", "=", alternatePath).first();
    }

    return page;
  }, {
    server: true,
    default: () => ({})
  });

  return page?.value?.body || {};
};


export default usePage;